import { api } from 'common';

import { EvaluationFormFields } from './FormFields';
import { evaluationDocumentationMarkdown } from './documentation';
import { getDefaultEvaluationConfig } from './utils';
import { type BlockConfigProps } from '../../types';

export const evaluationNodeConfig: BlockConfigProps<api.FlowDefinition.EvaluationBlockConfig> = {
  defaultLabelPrefix: 'evaluation',
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultConfig: getDefaultEvaluationConfig(),
  configFields: {
    schema: api.FlowDefinition.EvaluationBlockConfigSchema,
    FormFields: EvaluationFormFields,
  },
  documentationMarkdown: evaluationDocumentationMarkdown,
};
